import React, { useState, useEffect, useRef, useCallback } from 'react';
import '../Bidding/index.scss';

import {
    Carousel
} from 'antd';

import { useHistory } from 'react-router-dom';

import { getQueryString } from '../../approach/base';

function Home(props: any, ref: any) {
 
    const history = useHistory();

    const [type,setType] = useState("1");

    const [ companyList, setCompanyList ] = useState([]);
    const [ infoList, setInfoList ] = useState([]);

    const { getHistoryBidInfoList } = window.$axios.request;

    useEffect(() => {
        let type = getQueryString("type") || "";
        setType(type);
        _getIndexPageInfo(type);
    },[])

    const _getIndexPageInfo = (type:string) => {
        getHistoryBidInfoList({},{bidType: type,})
        .then((res:any) => {
            if(res.code == 1000){
                setInfoList(res.data)
            }
        })
    }

    const End = () => {
        return <div className='end'>
            <div className='content'>
                <div className='title'>
                    <div className='texts'>到底啦
                        <div className='left'></div>
                        <div className='right'></div>
                    </div>
                </div>
            </div>
            
        </div>
    }

    const Infomation = () => {
        return <div className='informations'>
            <div className='content'>
                <div className='information-lists'>
                    <div className='information-list'>
                        <div className='title' style={{
                            margin:0,
                            padding:"43px 0"
                        }}>
                            <div className='texts'><span className='name-color'>历史{type == "1"?"采购":type == "2"?"设计":"工程"}</span>招标信息
                                <div className='left'></div>
                                <div className='right'></div>
                            </div>
                        </div>
                        <div className='lists ub'>
                            {
                                infoList.map((item:any,index:number) => {
                                    return <div className='list ub ub-column ub-space-between' key={index}
                                    onClick={(e) => {
                                        window.open(item.mainBody);
                                    }}
                                    >
                                        <div className='top cut-2'>{item.mainTitle}</div>
                                        {
                                            item.attachmentBody && <div className='attachment'
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    window.open(item.attachmentBody);
                                                }}
                                            >
                                                <img className='banner-img' src={require("../../assets/images/fujian2.png")} alt="" />
                                                下载附件
                                            </div>
                                        }
                                        <div className='bottom ub ub-space-between'>
                                            <div className='time'>{item.beginDate}至{item.endDate}</div>
                                            <div className='toDetail cursor-pointer'>
                                                {"查看详情 >>"}
                                                {/* <a href={item.mainBody} target="_blank">{"查看详情 >>"}</a> */}
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }


    return (
        <div className="bidding">
            {Infomation()}
            {End()}
        </div>
    )
}
export default Home;